import type { Repository } from "@octopusdeploy/octopus-server-client";
import { HostingEnvironment } from "@octopusdeploy/octopus-server-client";

export async function getLiveStatus(repository: Repository, projectId: string, isGrpcHaEnabled: boolean) {
    const emptyLiveStatus = { ProjectLiveStatus: { Id: projectId, LiveStatusSourceTypes: [], Environments: [] } };

    const projectLiveStatusPromise = repository.KubernetesLiveStatus.getProjectDashboardLiveStatus(projectId);
    const licensePromise = repository.Licenses.getCurrentStatus();
    const serverNodesPromise = repository.OctopusServerNodes.all();

    const isSelfHosted = (await licensePromise).HostingEnvironment === HostingEnvironment.SelfHosted;
    const isRunningInHACluster = isSelfHosted && (await serverNodesPromise).length > 1;
    const disabledBecauseHaIsNotSupported = isRunningInHACluster && !isGrpcHaEnabled;
    if (disabledBecauseHaIsNotSupported) {
        return emptyLiveStatus;
    }

    return await projectLiveStatusPromise;
}
